import React, { Component } from 'react';
import { prefixLink } from 'gatsby-helpers';

import ContentPage from 'components/content-page';
import Meta from 'components/meta';
import OutboundLink from 'components/outbound-link';
import Wrapper from 'components/wrapper';
import { Link } from 'react-router';
import aubermensuel from './Aubermensuel.png';

import styles from './styles.module.css';

export default class About extends Component {
  render() {
    return (
      <ContentPage>
        <Meta title="À Propos" />
        <Wrapper>
          <div className={styles.intro}>
            <h1>Qui suis-je ?</h1>
            <p>
              Je suis en ce moment auto-entrepreneur à Paris. Diplomé en école
              d'ingénieur informatique à{' '}
              <OutboundLink to="http://www.epita.fr">l'EPITA</OutboundLink>,
              après 3 ans d'expériences professionnelles.
            </p>
            <p>
              J'ai décidé d'actualiser mes connaissances et de me lancer
              quelques petits défis techniques (du challenge !). Après avoir
              fini mes petits projets personnels qui me tenaient à coeur, je
              suis maintenant en freelance travaillant pour moi et pour les
              autres. Si vous avez un projet en tête,{' '}
              <Link to={prefixLink('/contact/')}>
                n'hésitez pas à me contacter
              </Link>.
            </p>

            <h1>Que disent les gens de moi ?</h1>

            <h4>Pierre-Emmanuel Merle (Reponsable Projet chez Saint-Gobain)</h4>
            <p>
              “Youcef est quelqu'un de très dynamique qui sait mettre une bonne
              ambiance dans une équipe.”
            </p>

            <h4>Olga Suzuki (Responsable Qualité chez PSHealth)</h4>
            <p>
              “Toujours envie de se surpasser, Youcef ne lâche rien tant qu'il
              est sûr de ne pas pouvoir y arriver.”
            </p>

            <h4>Le Magasine Aubermensuel</h4>
            <div className={styles.magasine}>
              <img
                src={aubermensuel}
                alt="Magasine Aubermensuel"
                role="Portrait"
              />
            </div>
          </div>
        </Wrapper>
      </ContentPage>
    );
  }
}

/*

            <h2>Ce que je veux ?</h2>
            <p>
              J'aimerais intégrer une start-up avec une idée innovante et dont
              la principale technologie utilisée est le{' '}
              <OutboundLink to="https://facebook.github.io/react/">
                React-Native
              </OutboundLink>.
            </p>
            <p>
              Dans l'idée, j'aimerais pouvoir être force de proposition que ce
              soit du point de vue technologique que fonctionnel. Je voudrais
              aussi que l'application soit de type{' '}
              <OutboundLink to="https://fr.wikipedia.org/wiki/Business_to_consumer">
                B2C
              </OutboundLink>, afin que je puisse en parler à tout le monde
              autour de moi.
            </p>
            <p>
              Tant que je n'ai pas trouvé la boîte de mes rêves, je suis
              disponible pour faire de petites applications.
            </p>
*/



// WEBPACK FOOTER //
// ./about/index.jsx